import { Component, OnInit, ElementRef, ViewChild, Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { CoreService } from '../../services/coreService/core.service';
import { CoreVm, AddCoreVm, FileModelVM, } from 'src/app/viewModels/core/core-vm';
import { FormGroup, FormControl, FormBuilder, Validators, } from '@angular/forms';
import { COMMA, ENTER, I } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { map, startWith } from 'rxjs/operators';
import { ModuleName } from '../../services/coreService/core.enum';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { OpenHTMLFormComponent } from 'src/app/middleware/common/openHtmlForm/openHtmlForm.component';
import { MatDialog } from '@angular/material/dialog';
import { MatDatepicker } from '@angular/material/datepicker';
import { formatDate } from '@angular/common';
import { forEach } from 'jszip';
import { PaycheckErrorComponent } from 'src/app/middleware/common/paycheckError/paycheckError.component';

@Pipe({
  name: 'utcDatePipe'
})
export class UtcDatePipe implements PipeTransform {
  transform(dateString: string): Date | string {

    if (!dateString) return ''; // Return empty string if dateString is null, undefined, or empty

    // Parse the date string as UTC
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day));
  }
}

@Component({
  selector: 'app-core-parent',
  templateUrl: './core-parent.component.html',
  styleUrls: ['./core-parent.component.scss'],
  providers: [UtcDatePipe]
})
export class CoreParentComponent implements OnInit {

  addressFormGroup: any = [];
  cityValue: any;
  stateValue: any;
  zipValue: any;
  countryValue: any;
  addressValueField: any = Object;
  cityValueField: any = Object;
  stateValueField: any = Object;
  zipValueField: any = Object;
  arryaControlNameIdpare: any = [];
  arrayControlNameSubfolderID: any = [];
  emptyArrya: any = [];
  isTypeChanged: boolean = false;
  checkboxnames: any = [];
  tagvalues: string;

  gModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
  };

  contactCoreListing: any[];
  folderList: any;
  folderID: number = 0;
  OfficeIDList: any = [];
  myOfficeID: any;
  matTabIndex: number = 0;
  associatedAPIs: any = [] = [];
  medicationList: any = [];
  carePeriodList: any = [];
  addCarePeriodErrors: any = [];
  medicationID: number;
  constructor(private formBuilder: FormBuilder, private statusConst: StatusConstant, private loaderService: LoaderService,
    private coreService: CoreService, private toastr: ToastrService, private settingService: SettingService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses, private constant: Constants,
    private _dataSharingService: DataSharingService, private coreVm: CoreVm, private addCoreVm: AddCoreVm,
    private fileModelVM: FileModelVM, private settingsService: SettingService, private route: ActivatedRoute,
    private sanitizer: DomSanitizer, private dialog: MatDialog
  ) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.currentUser = jwt_decode(token);
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));


    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

  }

  ImagePathURL: string = '';
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  chkStatusArry: any;
  coreFieldList: any;
  checkBoxList: any = [];
  currentUser: any;
  showSyncButton: boolean = false;
  medicationparentCheckBox: boolean = false;
  transactionUserName: any;
  transactionUserRole: any;
  openDocumentDetail: boolean = false;
  openbindFieldsDetail: boolean = false;
  showUserDetail: boolean = false;
  showContactList: boolean = false;
  showCreateTouches: boolean = false;
  showContactdetail: boolean = false;
  showShareFile: boolean = false;
  showShareFaxFile: boolean = false;
  documentViewer: boolean = false;
  htmlData: boolean = false;
  showCreateTask: boolean = false;
  showLinkPI: boolean = false;
  showTaskDetail: boolean = false;
  getFieldsListResponseHolder: any;
  fieldsList: any[] = [];
  fieldListFolderWise: any[] = [];
  dropdownlist: any;
  multipleDropdownList: any;
  getFieldModel = {
    userID: '',
    databaseID: 0,
    folderID: 0,
    officeID: 0,
    OfficeIDList: []
  };
  folderText = 'Task';
  dynamicArray: any;
  dynamicArrayEdit: any;
  dynamicArrayPhone: any = [];
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;

  dynamicArrayTemp: any;
  dynamicArrayEditTemp: any;
  dynamicArrayPhoneTemp: any;
  dynamicArrayAddressTemp: any;
  dynamicArrayWebsiteTemp: any;

  checkBoxFieldArray: Array<any> = [];
  checkBoxFieldAttribute: any = {
    Select: false,
  };

  inputTypeFieldArray: Array<any> = [];
  inputTypeFieldAttribute: any = {
    fieldText: '',
    placeholder: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    dropdownText: '',
  };

  showTextBoxField: boolean = false;
  showDropdownBoxField: boolean = false;
  showCheckboxField: boolean = false;
  clickEventsubscription: Subscription;
  coreUserList: any;
  responseHolder: any;
  transactionID: any;
  databaseId: string;
  organizationId: string;
  myFormGroup: FormGroup;
  TypeList: any = [];
  step = 0;
  TypeListForDropDown: any = [];
  TypeIdDrp: any;
  CityModel = {
    Name: '',
    databaseID: 0,
    userID: ''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID: ''
  };
  zipOption: any[];
  stateList: any[];
  cityOption: string[] = [];
  getTagListResponseHolder: any;
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize: 0
  };
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[];
  allTags: string[] = [];

  moduleName: string;
  contactVm = {
    DatabaseID: 0,
    OrganizationID: 0,
    UserID: '',
    PageIndex: 0,
    PageSize: 0,
    FolderId: 0,
    transactionID: '',
    subFolderID: 0,
    searchKey: '',
    contactID: 0,
  }
  companyVm = {
    DatabaseID: 0,
    OrganizationID: 0,
    UserID: '',
    PageIndex: 0,
    PageSize: 0,
    FolderId: 0,
    transactionID: '',
    subFolderID: 0,
    searchKey: '',
    companyID: 0,
  }
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  mainModuleName: string = "";
  CCCList: any = [] = [];
  PreviousButton: boolean = false;
  NextButton: boolean = false;
  showPaycheck: boolean = false;
  Module: string = "";
  // transactionID:number=0;
  openAI = false;
  pendingPatientId: any;
  ShowPointClickCare: boolean = false;
  showPCC: boolean = false;
  pccToolTip: string = "Send to PointClickCare";
  showDocumentMenu: boolean = true;
  showActivityMenu: boolean = true;
  showCustomInfoMenu: boolean = true;
  showTasksMenu: boolean = true;
  showEmailMenu: boolean = true;
  showFormReportsMenu: boolean = true;
  showMedicationsMenu: boolean = true;
  SubMenuModulesList: any = [] = [];

  ngOnInit(): void {
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];
    this.dynamicArrayAddressTemp = [];
    this.dynamicArrayPhoneTemp = [];
    this.mainModuleName = ModuleName.Core;

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if (Array.isArray(data) && data.length > 0) {
      this.SubMenuModulesList = [];
      if (data[0].children && Array.isArray(data[0].children)) {
        this.SubMenuModulesList = data[0].children.filter(x => x.isAssign === true);
        if (this.SubMenuModulesList.length > 0) {
          const firstModule = this.SubMenuModulesList[0];
          if (firstModule && firstModule.mainModuleName) {
            const moduleName = firstModule.mainModuleName.toUpperCase();

            // Reset all flags first
            this.showTouches = false;
            this.showCustomInfo = false;
            this.showTask = false;
            this.showEmail = false;
            this.showFormReports = false;

            // Set specific flag based on module name
            switch (moduleName) {
              case "ACTIVITY":
                this.showTouches = true;
                break;
              case "CUSTOM INFO":
                this.showCustomInfo = true;
                break;
              case "TASKS":
                this.showTask = true;
                break;
              case "EMAIL":
                this.showEmail = true;
                break;
              case "FORM REPORTS":
                this.showFormReports = true;
                break;
            }
          }
        }

      }
    }

    this._dataSharingService.getopenAIBindingFileDashboard().subscribe((result) => {
      this.openAI = result;
    });

    this._dataSharingService.getSelectedHTMLDataForCore().subscribe((result) => {
      if (result != null && result != "") {
        this.htmlData = true;
      }
    });
    // this.clickEventsubscription = this._dataSharingService.getSelectedCoreUser().subscribe((result) => {
    //     if (result !== '') {
    //       // let group = {};
    //       // this.myFormGroup = new FormGroup(group);      
    //       // var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    //       // var Module=[];
    //       // Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    //       // if(Module.length>0){     
    //       //   this.folderID = Module[0].folderID;
    //       //  } 

    //       this.transactionID = result.Id;
    //       this.moduleName = result.moduleName;
    //       sessionStorage.setItem('transactionID', result.Id);   
    //       sessionStorage.setItem('moduleName', result.moduleName); 

    //       // if(sessionStorage.getItem('moduleName') == ModuleName.Core) {           
    //       //   this.getCoreUserDetailsforSubFolderId(); 
    //       // }

    //       sessionStorage.setItem('HeaderModuleName', sessionStorage.getItem('moduleName'));
    //     }
    //   });

    this.mainModuleName = ModuleName.Core;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
      this.folderID = Module[0].folderID;
    }

    //var paychecks = sessionStorage.getItem('Paycheck');
    var PointClickCare = sessionStorage.getItem('PointClickCare');
    // if(paychecks=="true"){
    //   this.ShowPaycheck=true;
    // }
    if (PointClickCare == "true") {
      this.ShowPointClickCare = true;
    }

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    if (this.associatedAPIs.length > 0) {
      //var checkPayCheck = [];
      var checkPCC = [];

      // checkPayCheck = this.associatedAPIs.filter(x => x.apiName == 'Paychex' && x.isCoreMapped == true);
      // if (checkPayCheck.length > 0) {
      //   this.showPaycheck = true;
      // } else {
      //   this.showPaycheck = false;
      // }

      checkPCC = this.associatedAPIs.filter(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }

    this.route.queryParams.subscribe(params => {
      if (params != null) {
        this.transactionID = (params['tID']);
        this.TypeIdDrp = (params['type']);
        if (this.transactionID != undefined) {

          this.transactionID = atob(params['tID']);
          this.TypeIdDrp = atob(params['type']);

          this.getAllTagsList();
          this.getStateDropdownList(231);
          this.getCoreUserDetails();
          this.GetFormReportFolderMappingsFor3C();
          return;
        }
      }
    });

    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.moduleName = sessionStorage.getItem('moduleName');
    this.TypeIdDrp = Number(sessionStorage.getItem('TypeID'));
    this.transactionID = Number(sessionStorage.getItem('transactionID'));
    this.GetAllMedicationList();
    // sessionStorage.setItem('transactionID', sessionStorage.getItem('transactionID'));
    // sessionStorage.setItem('TypeID', sessionStorage.getItem('TypeID'));
    sessionStorage.setItem('moduleName', sessionStorage.getItem('moduleName'));

    this.getAllTagsList();
    this.getStateDropdownList(231);
    this.getCoreUserDetails();
    this.GetFormReportFolderMappingsFor3C();
    this.CCCList = JSON.parse(sessionStorage.getItem("coreList"));
    if(this.CCCList==null){
      this.CCCList=[];
    }
    if (this.CCCList.length > 0) {
      var transactionID = sessionStorage.getItem('transactionID');
      var Index = this.CCCList.findIndex(el => el.coreID === Number(transactionID));
      if (this.CCCList.length == 1) {
        this.PreviousButton = true;
        this.NextButton = true;
        return;
      }
      if (Index == 0) {
        this.PreviousButton = true;
        this.NextButton = false;
      }
      if (Index == this.CCCList.length - 1) {
        this.PreviousButton = false;
        this.NextButton = true;
      }
      if (Index != 0 && Index != this.CCCList.length - 1) {
        this.PreviousButton = false;
        this.NextButton = false;
      }
    }
    this._dataSharingService.getUpdateDataUsingAIForCore().subscribe((result) => {
      if (result) {
        this.getCoreUserDetails();
      }
    });
    //this.getCoreUserDetailsforSubFolderId();    
  }



  revertForm() {
    if (this.myFormGroup.dirty) {
      this.getCoreUserDetails();
      // this.getCoreUserDetailsforSubFolderId(); 
      this.myFormGroup.markAsPristine();
    }
  }

  getTransactionID() {
    return sessionStorage.getItem('transactionID');
  }

  getAddressField(addressFieldsArray: any, type: number) {
    let field = addressFieldsArray.find(m => m.childFieldType == type);
    return field.fieldValue
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();

    this.allTags;
    var check = [];
    check = this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if (check.length > 0) {
      this.fruitCtrl.setValue(null);
      return;
    }

    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
    this.myFormGroup.markAsDirty();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags = this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';
      //this.fruits.splice(index, 1);
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }


  // getCoreUserDetailsforSubFolderId() {
  //   this.coreUserList = [];
  //   this.coreVm.DatabaseID = Number(this.databaseId);
  //   this.coreVm.OrganizationID = Number(this.organizationId);
  //   this.coreVm.coreID = Number(sessionStorage.getItem('transactionID'));
  //   this.coreVm.FolderId = this.folderID;//this.transactionID; 
  //   this.coreVm.UserID= this.currentUser.UID;     
  //   this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConst.statusSuccess) {                   
  //         var TypeData =  response.data.fields.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');       

  //         if (TypeData.length > 0 && TypeData !=undefined) {            
  //           if(TypeData[0].fieldValue != ""){
  //             let id: string = TypeData[0].fieldValue.toString();
  //             this.TypeIdDrp = parseInt(id);             
  //           }
  //           else {              
  //             this.TypeIdDrp=0;
  //           }           
  //         }
  //         else{
  //           this.TypeIdDrp=0;
  //         }         
  //         this.getCoreUserDetails();
  //       }
  //     }      
  //   });
  // }


  // get core medications
  selectedPCCMedication: any = [];
  CheckMedicationBox(checked, medicine) {
    if (checked) {
      this.showSyncButton = true;
      if (this.medicationList.find(m => m.medicationID == medicine.medicationID)) {
        this.selectedPCCMedication.push(medicine.medicationID);
        this.medicationList.find(m => m.medicationID == medicine.medicationID).checked = true;
      }
    } else {
      if (this.medicationList.find(m => m.medicationID == medicine.medicationID)) {
        this.selectedPCCMedication = this.selectedPCCMedication.filter(m => m != medicine.medicationID);
        this.medicationList.find(m => m.medicationID == medicine.medicationID).checked = false;
      }
      this.medicationparentCheckBox = false;
      if (!this.medicationparentCheckBox) {
        let anyChecked = this.medicationList.some(med => med.checked);
        if (anyChecked)
          this.showSyncButton = true;
        else
          this.showSyncButton = false;

      }
    }
  }

  CheckAllBoxes(checked) {
    if (checked) {
      this.showSyncButton = true;
      this.medicationList.forEach(element => {
        element.checked = true;
      });
    } else {
      this.showSyncButton = false;
      this.medicationList.forEach(element => {
        element.checked = false;
      });
    }
  }


  showError(error: any[]) {
    // Create a container div for the popup
    const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.left = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.width = '80%';
    popup.style.maxWidth = '800px';
    popup.style.maxHeight = '150vh';
    popup.style.backgroundColor = 'white';
    popup.style.border = '1px solid #ccc';
    popup.style.borderRadius = '8px';
    popup.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    popup.style.zIndex = '1000';
    popup.style.overflow = 'auto';
    popup.style.padding = '20px';

    // Create a close button
    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '10px';
    closeButton.style.right = '10px';
    closeButton.style.background = 'none';
    closeButton.style.border = 'none';
    closeButton.style.fontSize = '20px';
    closeButton.style.cursor = 'pointer';
    closeButton.onclick = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popup);
    };

    // Create a title
    const title = document.createElement('h2');
    title.textContent = 'Medication Errors';
    title.style.marginTop = '0';
    title.style.color = '#d32f2f';

    // Create a container for error items
    const errorContainer = document.createElement('div');

    // Process each error
    const medicationDiv = document.createElement('div');
    medicationDiv.style.marginBottom = '15px';
    medicationDiv.style.padding = '10px';
    medicationDiv.style.borderBottom = '1px solid #eee';


    const nameLabel = document.createElement('strong');
    nameLabel.textContent = error[0].MedicationName || 'Unknown Medication';
    nameLabel.style.display = 'block';
    nameLabel.style.marginBottom = '5px';
    nameLabel.style.fontSize = '16px';
    medicationDiv.appendChild(nameLabel);
    let index = 1;
    error.forEach(err => {

      const errorDetail = document.createElement('div');
      errorDetail.textContent = index + ". " + err.detail || index + '. No error details available';
      errorDetail.style.color = '#666';
      errorDetail.style.whiteSpace = 'pre-wrap'; // Preserve formatting and wrap text
      errorDetail.style.overflowWrap = 'break-word'; // Break long words if needed


      medicationDiv.appendChild(errorDetail);
      index = index + 1;
    });

    errorContainer.appendChild(medicationDiv);

    // Add elements to popup
    popup.appendChild(closeButton);
    popup.appendChild(title);
    popup.appendChild(errorContainer);

    // Add overlay
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
    overlay.style.zIndex = '999';
    overlay.onclick = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popup);
    };

    // Add to document
    document.body.appendChild(overlay);
    document.body.appendChild(popup);
  }

  validateMedicationList(medicationList: any[]): any[] {
    const validScheduleTypes = [
      "Everyday",
      "Odd Days",
      "Even Days",
      "Every Other Day",
      "Other"
    ];

    return medicationList.map(medicine => {
      // Always required fields validation
      const isNameValid = !!medicine.name;
      const isDosageValid = !!medicine.dosage;
      const isDosageUOMValid = !!medicine.dosage_UOM;
      const isScheduleValid = !!medicine.schedule;
      const isRouteValid = !!medicine.route;
      const isStatusValid = !!medicine.status;

      // Conditional validation based on schedule
      let isConditionallyValid = true;

      if (medicine.schedule && medicine.schedule.toLowerCase() === 'Routine'.toLowerCase()) {
        const scheduleType = medicine.scheduleType?.toLowerCase();
        const isMatch = validScheduleTypes.some(type => type.toLowerCase() === scheduleType);

        isConditionallyValid = !!medicine.frequency && !!medicine.scheduleType && isMatch;
        // isConditionallyValid = !!medicine.frequency && !!medicine.scheduleType;
      }
      else if (medicine.schedule && medicine.schedule.toLowerCase() === 'Titration'.toLowerCase()) {
        isConditionallyValid = false;
      }
      else if (medicine.schedule === 'PRN') {
        if ((!medicine.isPrnWithDirections) == true) {
          isConditionallyValid = !!medicine.prnTiming && !!medicine.prnTimingValue
        }
        else {
          isConditionallyValid = !!medicine.additionalDirections
        }
      }
      // No additional validation needed for 'One Time Only' or 'STAT'

      // Determine overall validity
      medicine.not_valid = !(
        isNameValid &&
        isDosageValid &&
        isDosageUOMValid &&
        isScheduleValid &&
        isRouteValid &&
        isStatusValid &&
        isConditionallyValid
      );

      return medicine;
    });
  }

  GetAllMedicationList() {
    //this.medicationList=[];
    let reqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      CoreID: Number(sessionStorage.getItem('transactionID'))
    }
    this.settingsService.GetAllMedicationList(reqModel).subscribe((response: any) => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          //this.medicationList = response.data;
          this.medicationList = response.data;
          if (this.medicationList && this.medicationList.length > 0) {
            this.medicationList.forEach(element => {
              if (element.dosage && element.dosage != "Not specified" && element.dosage_UOM && element.dosage_UOM != "Not specified") {
                element.modifiedDose = element.dosage + " " + element.dosage_UOM;
              }
              if (element.dosage && element.dosage == "Not specified") {
                element.dosage = "";
              }
              if (element.dosage_UOM && element.dosage_UOM == "Not specified") {
                element.dosage_UOM = "";
              }

              if (element.name && element.name == "Not specified") {
                element.name = "";
              }

              if (element.route && element.route == "Not specified") {
                element.route = "";
              }

              if (element.errorJson && element.errorJson != null && element.errorJson != undefined && element.errorJson != "") {
                element.errorJson = JSON.parse(element.errorJson);
              }
              if (element.startDate && element.startDate != "Not specified") {
                element.startDate = this.formatDateForDisplay(element.startDate);
              }

              if (element.endDate && element.endDate != "Not specified") {
                element.endDate = this.formatDateForDisplay(element.endDate);
              }
            });
          }
          this.medicationList = this.validateMedicationList(this.medicationList);
        }
        else {
        }
      }
    });
  }

  // get Tag List


  getAllTagsList() {

    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';
    this.getTagListModel.PageSize = 0;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;
        }
        else {
        }
      }
    });
  }

  isChecked(fieldName, chk) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    if (_newcheckBoxlist[0].selectedCHK != '') {
      return _newcheckBoxlist[0].selectedCHK.toString().includes(chk);
    } else {
      return false;
    }
  }

  OnChange($event: any, chk: any, fieldId: any) {
    this.myFormGroup.get(chk).markAsDirty();
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {
      if (this.chkStatusArry.length > 0) {
        var checkRecord = [];
        checkRecord = this.chkStatusArry.filter(x => x.fieldId == fieldId);
        if (checkRecord.length > 0) {
          this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = chk;
        }
      } else {
        this.chkStatusArry.push({
          ckh: chk,
          fieldId: fieldId,
        });
      }
    } else {
      if (this.chkStatusArry.length > 0) {
        this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = '';
      }
      // if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
      //   this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
      // }
    }
  }

  getddlSelectedVal(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist[0] && _newdropdownlist[0].selectedVal != '' && _newdropdownlist[0].selectedVal != undefined && _newdropdownlist[0].selectedVal != null) {
        return _newdropdownlist[0].selectedVal;
      } else {
        return '';
      }
    }
  }

  getMultiddlSelectedVal(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist[0] && _newMuldropdownlist[0].selectedVal != '') {
        if (fieldName != "Tags") {
           var test12 = _newMuldropdownlist[0].selectedVal.split(',');
          return _newMuldropdownlist[0].selectedVal.split(',');        
        } else {
          return _newMuldropdownlist[0].selectedVal;
        }
      } else {
        return '';
      }
    }
  }


  getCheckBoxlist(fieldName) {
    if (this.checkBoxList) {
      var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
      if (_newcheckBoxlist[0]) {
        _newcheckBoxlist[0].value.forEach(v => {
          this.myFormGroup.addControl(v, this.formBuilder.control(''));
        });
        return _newcheckBoxlist[0].value;
      }
    }
  }

  getdropdownlist(fieldName) {
    if (this.dropdownlist) {
      var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
      if (_newdropdownlist.length > 0)
        return _newdropdownlist[0].value;
      else
        "";
    }
  }

  showAddCarePeriod = false;

  addCarePeriod() {
    this.showAddCarePeriod = !this.showAddCarePeriod;
  }

  getMuldropdownlist(fieldName) {
    if (this.multipleDropdownList) {
      var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
      if (_newMuldropdownlist.length > 0)
        return _newMuldropdownlist[0].value;
      else
        "";
    }
  }


  fillCheckBoxList() {
    if (this.coreFieldList) {
      this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');
    }
  }

  prepareCheckboxListForUI() {
    if (this.checkBoxList.length > 0 && this.checkBoxList != undefined) {
      var fieldcheckbox = [];
      this.chkStatusArry = [];
      var value;
      if (!this.chkStatusArry) {
        this.chkStatusArry = [];
      }
      for (let i = 0; i < this.checkBoxList.length; i++) {
        var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
        value = checkboxValue.split(',');
        var selectedVal;
        let chk = this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID);

        if (chk.length > 0) {
          selectedVal = chk[0].fieldValue;
          selectedVal = selectedVal.replace(/,/g, '');
        }
        else {
          selectedVal = this.checkBoxList[i].fieldValue;
          selectedVal = selectedVal.replace(/,/g, '');
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }

        var FieldsCheckbox = {
          FieldValue: this.checkBoxList[i].fieldName,
          value: value,
          selectedCHK: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue),checked: false,
        };

        fieldcheckbox.push(FieldsCheckbox);

        let selectedCHKArray = selectedVal.split(','); //this.coreUserList.filter((m) => m.fieldID == this.checkBoxList[i].fieldID).map((k) => k.fieldValue).toString().split(',');
        for (let n = 0; n < selectedCHKArray.length; n++) {
          this.chkStatusArry.push({
            ckh: selectedCHKArray[n],
            fieldId: this.checkBoxList[i].fieldID,
          });
        }
      }
      this.checkBoxList = fieldcheckbox;
    }
  }

  fillMultiDropDown() {
    this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
  }

  openFieldURL(val: any) {
    //const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(val);
    window.open(val as string, '_blank');
  }

  prepareMultiDropDownForUI() {
    if (this.multipleDropdownList.length > 0) {
      var fieldmulListdrp = [];
      var value;
      for (let i = 0; i < this.multipleDropdownList.length; i++) {
        var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
        value = muldrpValue.split(',');
        var selectedVal;
        let drp = this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID);
        if (drp.length > 0) {
          selectedVal = drp[0].fieldValue;
        }
        else {
          selectedVal = this.multipleDropdownList[i].fieldValue
        }

        if (selectedVal == undefined || selectedVal == null) {
          selectedVal = "";
        }        

        var FieldsMulDrp = {
          FieldValue: this.multipleDropdownList[i].fieldName,
          value: value,
          selectedVal: selectedVal// this.coreUserList.filter((m) => m.fieldID == this.multipleDropdownList[i].fieldID).map((k) => k.fieldValue).toString().split(','),
        };
        fieldmulListdrp.push(FieldsMulDrp);
        var selectedValNew="";

        if(this.multipleDropdownList[i].fieldName != "Tags"){   
           selectedValNew = selectedVal.split(',');          
           this.myFormGroup.get(this.multipleDropdownList[i].fieldName).setValue((selectedValNew));
        } 
      }
      this.multipleDropdownList = fieldmulListdrp;
    }
  }

  fillDropDown() {
    this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
    this.dropdownlist.forEach(element => {
      if (element.fieldName == 'Type') { element.defaultValue = this.TypeList }
    });
  }

  prepareDropDownForUI() {
    if (this.dropdownlist.length > 0) {
      var fieldListdrp = [];
      var value;
      for (let i = 0; i < this.dropdownlist.length; i++) {

        if (this.dropdownlist[i].defaultValue.length > 0) {
         // var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
        //  value = drpValue.split(',');
          var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");
          //value = drpValue.split(',');
          value = drpValue.split(',').map(item => item.trim());

          var selectedVal;
          let drp = this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID);
          if (drp.length > 0) {
            selectedVal = drp[0].fieldValue;
          }
          else {
            selectedVal = this.dropdownlist[i].fieldValue
          }

          if (selectedVal == undefined || selectedVal == null) {
            selectedVal = "";
          }

          if (this.dropdownlist[i].fieldName == "Status") {
            selectedVal = this.statusType;
          }

          
          var FieldsDrp = {
            FieldValue: this.dropdownlist[i].fieldName,
            value: value,
            selectedVal: selectedVal //this.coreUserList.filter((m) => m.fieldID == this.dropdownlist[i].fieldID).map((k) => k.fieldValue),
          };
          fieldListdrp.push(FieldsDrp);
        }
      }
      this.dropdownlist = fieldListdrp;
    }
  }

  getCurrentIndex(fieldName: any) {
    for (let i = 1; i < 10; i++) {
      if (!this.myFormGroup.contains(fieldName + i)) {
        length = i;
        return i;
      }
    }
  }

  appendEle(field: any, type: any, index: any) {
    this.myFormGroup.addControl(field.fieldName, this.formBuilder.control(''));
    this.myFormGroup.addControl(
      field.fieldName + 'option',
      this.formBuilder.control('')
    );
    let plcHolder = field.fieldNames.find((x) => x.fieldNameID == field.fieldNameID);

    let addressRefactor: any = [];
    if (field.address != undefined && field.address.length > 0) {
      addressRefactor.push(field.address.find(x => x.childFieldType == 0));
      addressRefactor.push(field.address.find(x => x.childFieldType == 3));
      addressRefactor.push(field.address.find(x => x.childFieldType == 2));
      addressRefactor.push(field.address.find(x => x.childFieldType == 4));
    }

    // addressRefactor.splice(2,0,field.address.find(x=>x.childFieldType==3));
    let uiField = {
      fieldID: field.fieldID,
      fieldName: field.fieldName,
      fieldNameID: field.fieldNameID,
      fieldNames: field.fieldNames,
      fieldTypeID: field.fieldTypeID,
      fieldTypeName: field.fieldTypeName,
      fieldValue: field.fieldValue,
      transactionID: field.transactionID,
      placeholderVal: plcHolder != null ? plcHolder.fieldName : '',
      address: addressRefactor,
      isPrimary: field.isPrimary
    };


    //1 Email ,2 Address,3 Phone,4 website
    if (type == 2) {
      this.myFormGroup.addControl('City' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + index, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + index, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + index);
      this.addressFormGroup.push('City' + index);
      this.addressFormGroup.push('State' + index);
      this.addressFormGroup.push('ZipCode' + index);
      this.addressFormGroup.push('Country' + index);
    }
    if (type == 1) this.dynamicArray.push(uiField);
    if (type == 2) this.dynamicArrayAddress.push(uiField);
    if (type == 3) this.dynamicArrayPhone.push(uiField);
    if (type == 4) this.dynamicArrayWebsite.push(uiField);
  }

  addMore(fieldName: any) {
    if (fieldName.includes('Email')) {
      fieldName = 'Email';
      let length = this.dynamicArray.length;
      length = this.getCurrentIndex('Email');
      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          ctrl = formControl;
        }
      });

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArray.push(field);
      }
    }
    // Phone
    if (fieldName.includes('Phone')) {
      fieldName = 'Phone';
      let length = this.dynamicArrayPhone.length;
      length = this.getCurrentIndex('Phone');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayPhone.push(field);
      }
    }
    //Address
    if (fieldName.includes('Address')) {
      fieldName = 'Address';
      if (this.dynamicArrayAddress == undefined) this.dynamicArrayAddress = [];
      let length = this.dynamicArrayAddress.length;
      length = this.getCurrentIndex('Address');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      this.addressValueField[fieldName + length] = '';
      this.cityValueField['City' + length] = '';
      this.stateValueField['State' + length] = '';
      this.zipValueField['ZipCode' + length] = ''
      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          ctrl = formControl;
        }
      });

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length, this.formBuilder.control(''));

      // address array for computation
      this.addressFormGroup.push('Address' + length);
      this.addressFormGroup.push('City' + length);
      this.addressFormGroup.push('State' + length);
      this.addressFormGroup.push('ZipCode' + length);
      this.addressFormGroup.push('Country' + length);

      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var fieldAddress = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
          address: this.emptyArrya
        };
        this.dynamicArrayAddress.push(fieldAddress);
      }
    }
    //Website
    if (fieldName.includes('WebSite')) {
      fieldName = 'WebSite';
      let length = this.dynamicArrayWebsite.length;
      length = this.getCurrentIndex('WebSite');

      this.myFormGroup.addControl(fieldName + length, this.formBuilder.control(''));
      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      var ctrl: any;
      this.coreFieldList.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          ctrl = formControl;
        }
      });
      let plcHolder = ctrl.fieldNames[0].fieldName;

      if (ctrl) {
        var field = {
          fieldID: ctrl.fieldID,
          fieldName: fieldName + length,
          fieldNames: ctrl.fieldNames,
          fieldTypeID: ctrl.fieldTypeID,
          fieldTypeName: ctrl.fieldTypeName,
          folderID: ctrl.folderID,
          isRequired: ctrl.isRequired,
          placeholder: ctrl.placeholder,
          position: ctrl.position,
          placeholderVal: plcHolder != null ? plcHolder : '',
        };
        this.dynamicArrayWebsite.push(field);
      }
    }
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }

  getAddressTypeFieldName(childFieldType) {
    if (childFieldType == 3)
      return 'City';
    if (childFieldType == 2)
      return 'State';
    if (childFieldType == 4)
      return 'ZipCode';
    if (childFieldType == 1)
      return 'Country';
  }

  getCoreUserDetailsOnTypeChange(event: any, fieldName: any) {
    this.transactionID;
    this.isTypeChanged = true;
    this.TypeIdDrp = parseInt(event.value);
    this.arryaControlNameIdpare = []
    this.arrayControlNameSubfolderID = [];
    this.getCoreUserDetails();
  }

  transactionIDForTask: number = 0;
  typeIdForTask: number = 1;
  NameForTask: string = "";
  EmailForTask: string = "";
  ImageForTask: string = "";
  statusType: string = "";

  entityId: number = 0;
  convertToUTCDate(dateString: string): Date | string {

    if (!dateString) return '';

    // Split the date and time parts by 'T'
    const [datePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-').map(Number)
    const date = new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Month is zero-based
    //let newUTCDate=this.formatAsUTC(date); 
    return date;
  }


  getCoreUserDetails() {
    let thirdPartyApiID = 0;
    let officeThirdPartyApiID = 0;

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    if (this.associatedAPIs && this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
      thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
      officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
    }

    this.transactionIDForTask = Number(this.transactionID);//Number(sessionStorage.getItem('transactionID'));
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.coreID = Number(this.transactionID); //Number(sessionStorage.getItem('transactionID'));
    this.coreVm.FolderId = Number(this.folderID);
    this.coreVm.subFolderID = Number(this.TypeIdDrp);
    //this.coreVm.subFolderID = Number(sessionStorage.getItem('TypeID'));// Number(this.TypeIdDrp); 
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.coreVm.thirdPartyApiID = thirdPartyApiID;
    this.coreVm.officeThirdPartyApiID = officeThirdPartyApiID;
    this.loaderService.show();
    this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          sessionStorage.setItem("PCCPatientID", response.data.patientId);
          sessionStorage.setItem("PCCPendingPatientID", response.data.pendingPatientId);
          this.statusType = response.data.status;
          this.coreUserList = response.data.fields;
          this.ImageForTask = response.data.imageUrl;
          this.entityId = response.data.coreID;
          this.pendingPatientId = response.data.pendingPatientId;
          if (this.pendingPatientId == null) {
            this.pccToolTip = "Send to PointClickCare";
          } else {
            this.pccToolTip = "Update to PointClickCare";
          }
          var checkName = [];
          var checkEmail = [];
          checkName = response.data.fields.filter(x => x.fieldName.toLowerCase() == "Name".toLowerCase());
          if (checkName.length > 0) {
            this.NameForTask = checkName[0].fieldValue;
          }
          checkEmail = response.data.fields.filter(x => x.fieldName.toLowerCase() == "Email".toLowerCase());
          if (checkEmail.length > 0) {
            this.EmailForTask = checkEmail[0].fieldValue;
          }
          if (this.responseHolder.data.paychexID == null) {
            this.showPaycheck = false;
          } else {
            this.showPaycheck = true;
          }
          this.TypeListForDropDown = response.data.types;
          this.TypeListForDropDown.splice(0, 0, { folderName: "Select", isChecked: false, subFolderID: 0 });

          var TypeData = this.coreUserList.filter((e) => e.fieldTypeName == 'Dropdown' && e.fieldName == 'Type');

          var taglist;
          taglist = this.coreUserList.filter((e) => e.fieldTypeName == 'MultiSelect' && e.fieldName == 'Tags');
          if (taglist.length > 0 && taglist != undefined) {
            this.tags = [];
            if (taglist[0].fieldValue != "") {
              var str = taglist[0].fieldValue;
              var selectedValues = str.replace(/^,|,$/g, '');
              this.tags = selectedValues.split(',');
            }
            else {
              this.tags = [];
            }
          }
          else {
            this.tags = [];
          }

          var NewList;
          NewList = response.data.fields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreUserList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);
          this.coreUserList = NewList;

          //Change name for dynamic elements
          //Group them one beneath othe for multi name array
          let multiNameArray = [];
          let ArrayWithGroupedElement = [];
          this.coreUserList = this.coreUserList.filter((s) => s.availableOn != 2);
          this.coreUserList = this.coreUserList.filter((s) => s.rolePermission != 2);

          this.arryaControlNameIdpare = [];
          this.coreUserList.forEach((formControl) => {
            if (formControl.fieldTypeName == 'Date') {
              formControl.fieldValue = this.convertToUTCDate(formControl.fieldValue);
            }
            let count = multiNameArray.filter((x) => x.fieldID == formControl.fieldID).length;
            if (count == 0) {
              multiNameArray.push(formControl);
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });

              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType),
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
            else if (count > 0) {
              multiNameArray.push(formControl);
              formControl.fieldName = formControl.fieldName + count;
              //  Save control name and ID
              this.arryaControlNameIdpare.push({
                name: formControl.fieldName,
                id: formControl.id,
                subFolderID: formControl.subFolderID
              });
              this.arrayControlNameSubfolderID.push({
                name: formControl.fieldName,
                id: formControl.id,
                subfolderID: formControl.subFolderID
              });
              if (formControl.fieldName.includes('Address')) {
                formControl.address.forEach((ac, i) => {
                  if (i > 0)
                    this.arryaControlNameIdpare.push({
                      name: this.getAddressTypeFieldName(ac.childFieldType) + count,
                      id: ac.id,
                      subFolderID: ac.subFolderID
                    });
                  this.arrayControlNameSubfolderID.push({
                    name: this.getAddressTypeFieldName(ac.childFieldType),
                    id: ac.id,
                    subfolderID: formControl.subFolderID
                  });
                });
              }
            }
          });


          this.coreUserList.forEach((formControl) => {
            let count = ArrayWithGroupedElement.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0).length;
            let elements = this.coreUserList.filter((x) => x.fieldID == formControl.fieldID && formControl.fieldNames.length > 0);
            if (count == 0 && elements.length > 0) {
              if (elements[0].fieldName.includes('Address')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Address');
                this.dynamicArrayAddressTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Email')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Email');
                this.dynamicArrayTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Phone')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Phone');
                this.dynamicArrayPhoneTemp = this.dynamicArrayEdit;
              }

              if (elements[0].fieldName.includes('Website')) {
                this.dynamicArrayEdit = elements.filter((x) => x.fieldName != 'Website');
                this.dynamicArrayWebsiteTemp = this.dynamicArrayEdit;
              }

              ArrayWithGroupedElement.push(elements[0]);
            }
            if (count == 0 && elements.length == 0)
              ArrayWithGroupedElement.push(formControl);
          });

          this.coreUserList = ArrayWithGroupedElement;

          const Fields = {};
          this.coreUserList.forEach((formControl) => {
            if (formControl.fieldName == 'Name') {
              this.transactionUserName = formControl.fieldValue;
            }
            if (formControl.fieldName == 'Type') {
              let type = this.TypeListForDropDown.find(x => x.subFolderID == formControl.fieldValue);
              this.transactionUserRole = (type != null || type != undefined) ? type.folderName : ""
            }
            Fields[formControl.fieldName] = new FormControl('');
            if (formControl.fieldNames.length > 0) {
              Fields[formControl.fieldName + 'option'] = new FormControl('');
              let plcHolder = formControl.fieldNames.find((x) => x.fieldNameID == formControl.fieldNameID);
              formControl.placeholderVal = plcHolder != null ? plcHolder.fieldName : formControl.fieldNames[0];
            }
          });
          this.ImagePathURL = (response.data.imageUrl == null || response.data.imageUrl == undefined || response.data.imageUrl == '') ? '' : response.data.imageUrl;

          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();

          // address computaion array for computation
          this.addressFormGroup.push('Address');
          this.addressFormGroup.push('City');
          this.addressFormGroup.push('State');
          this.addressFormGroup.push('ZipCode');
          this.addressFormGroup.push('Country');

          Fields['fruitCtrl'] = this.fruitCtrl;
          this.myFormGroup = new FormGroup(Fields);

          //#region geting core filds
          var reqModel = {
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
            folderID: this.folderID,//17;
            subFolderID: Number(this.TypeIdDrp),
            fieldID: 0,
            requestFrom: 0,
            officeID: this.myOfficeID,
            OfficeIDList: this.OfficeIDList
          }
          this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
            var tempArryacoreFieldList = response.data.activeFields.filter((m) => m.fieldID == 0);
            response.data.activeFields = response.data.activeFields.filter((m) => m.fieldID > 0);
            this.coreFieldList = response.data.activeFields;
            // Modified array containing group starts
            tempArryacoreFieldList.forEach(element => {
              if (element.data.length > 1) {
                var indexArray = [];
                element.data.forEach(elementin => {
                  if (elementin.fieldID > 0) {
                    let grpele = this.coreUserList.find(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    elementin.fieldValue = grpele != undefined ? grpele.fieldValue : "";
                    elementin.id = grpele != undefined ? grpele.id : 0;
                    elementin.isRequired = grpele != undefined ? grpele.isRequired : false;
                    if (elementin.fieldNames.length > 0) {
                      elementin.fieldNameID = grpele.fieldNameID;
                      elementin.placeholderVal = grpele.placeholderVal;
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName)) {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreUserList.findIndex(x => x.fieldName == elementin.fieldName && x.fieldID == elementin.fieldID);
                    indexArray.push(index);
                  }
                });

                this.coreUserList = this.coreUserList.filter(function (value, index) {
                  return indexArray.indexOf(index) == -1;
                });
                this.coreUserList.splice(indexArray[0], 0, element);
              }
            });

            ArrayWithGroupedElement.forEach(element => {
              if (element.fieldName == "Address") {
                if (element.address.length > 0) {
                  if (element.address.find(m => m.childFieldType == 3) != undefined)
                    this.cityValue = element.address.find(m => m.childFieldType == 3).fieldValue;
                  else
                    this.cityValue = "";
                  if (element.address.find(m => m.childFieldType == 2) != undefined)
                    this.stateValue = element.address.find(m => m.childFieldType == 2).fieldValue;
                  else
                    this.stateValue = "";
                  if (element.address.find(m => m.childFieldType == 4) != undefined)
                    this.zipValue = element.address.find(m => m.childFieldType == 4).fieldValue;
                  else
                    this.zipValue = "";
                }
              }
            });

            this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
            this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
            this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

            var data = [];

            data = this.coreUserList.filter((s) => s.fieldID == 0);

            if (data.length > 0) {
              for (var i = 0, len = data.length; i < len; ++i) {
                var DrpData = [];
                DrpData = data[i].data.filter((s) => s.fieldTypeName == 'Dropdown');
                if (DrpData.length > 0) {
                  for (var v = 0, char = DrpData.length; v < char; ++v) {
                    this.dropdownlist.push(DrpData[v]);
                  }
                }

                var MultiData = [];
                MultiData = data[i].data.filter((s) => s.fieldTypeName == 'MultiSelect');
                if (MultiData.length > 0) {
                  for (var v = 0, char = MultiData.length; v < char; ++v) {
                    this.multipleDropdownList.push(MultiData[v]);
                  }
                }

                var CheckboxData = [];
                CheckboxData = data[i].data.filter((s) => s.fieldTypeName == 'Checkbox');
                if (CheckboxData.length > 0) {
                  for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                    this.checkBoxList.push(CheckboxData[v]);
                  }
                }
              }
            }

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {
                //var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
               // value = drpValue.split(',');
                var drpValue = this.dropdownlist[i].defaultValue.trim().replace(/,\s*$/, "");                 
                value = drpValue.split(',').map(item => item.trim());

                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                 // selectedVal:'T1,T2'
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
              
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }

            // Modified array containing group ends 
            this.fillCheckBoxList();
            this.prepareCheckboxListForUI();

            this.fillDropDown();
            this.prepareDropDownForUI();

            this.fillMultiDropDown();
            this.prepareMultiDropDownForUI();
          });

          this.dynamicArray = [];
          this.dynamicArrayAddress = [];
          this.dynamicArrayPhone = [];
          this.dynamicArrayWebsite = [];
          this.dynamicArrayTemp.forEach((e, i) => {
            this.appendEle(e, 1, i + 1);
          });
          this.dynamicArrayAddressTemp.forEach((e, i) => {
            this.appendEle(e, 2, i + 1);
          });
          this.dynamicArrayPhoneTemp.forEach((e, i) => {
            this.appendEle(e, 3, i + 1);
          });
          if (this.dynamicArrayWebsiteTemp != undefined)
            this.dynamicArrayWebsiteTemp.forEach((e, i) => {
              this.appendEle(e, 4, i + 1);
            });
          this.loaderService.hide();
          if (this.isTypeChanged) {
            this.myFormGroup.get('Type').markAsDirty();
            this.isTypeChanged = false;
          }
         
        } else {
          this.coreUserList = [];
        }
      } else {
        this.loaderService.hide();
      }
    });
  }



  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConst.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x) => x.abbreviation != null);
              response.data.forEach(e => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach(e => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }

  searchZip(zip: any) {
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.zipOption = [];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name: any) {
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {
          this.cityOption = [];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }


  // getSubFolderFields(event, fieldName) {   
  //   if (event != undefined && fieldName == "Type") {
  //     this.TypeIdDrp =event.value;    
  //    }
  // }

  getShortName(fullName) {
    if (fullName != undefined) {
      if (fullName.includes(' ')) {
        return fullName
          .split(' ')
          .map((n) => n[0])
          .join('');
      }
      return fullName.substring(0, 1);
    }
    return '';
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var name = filename.split('.');
    this.FileName = name[0];
    this.FileExtention = '.' + name[1];
    this.myFormGroup.markAsDirty();
  }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ImagePathURL = response.data;
        }
      }
    });
  }


  SaveCoreUserDetails(formValues: any) {
    this.saveCoreDetails(formValues);
  }


  saveCoreDetails(formValues) {
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.CoreID = Number(sessionStorage.getItem('transactionID'));//Number(this.transactionID);
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      var fieldList = [];
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldList.find((m) => m.fieldName == key)) {
          this.coreFieldList.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldList.find((m) => key.includes(m.fieldName));

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option') &&
            control
          ) {
            if (control.fieldNames.length > 0) {
              tempList.push({
                fieldID: Number(control.fieldID),
                fieldName: key,
                fieldValue: formValues[key],
                fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option'] == '')
                    ? control.fieldNames[0].fieldNameID
                    : Number(formValues[key + 'option']),
              });
            }
          }
        }

        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0) {
              var selectedValueChk = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');

              var str = selectedValueChk;
              selectedValues = str.replace(/^,|,$/g, '');

              selectedValues = Array.from(new Set(selectedValues.split(','))).toString();

            } else {
              selectedValues = '';
            }
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues = this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.TypeIdDrp != undefined) {
                selectedValues = this.TypeIdDrp.toString();
              } else {
                selectedValues = '0';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];//.join();
              }
            }
          }

          if (tempList[0].fieldTypeName == 'Image') {
            selectedValues = this.ImagePathURL;
          }
          let frmctrl = this.arryaControlNameIdpare.find(e => e.name == key);
          let ctrlsfi = this.arrayControlNameSubfolderID.find(e => e.name == key);
          let localDateOnly = "";
          if (tempList[0].fieldTypeName == 'Date') {
            let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;

            // If selectedDate is a string, set localDateOnly to the string value directly
            if (typeof selectedDate === "string") {
              localDateOnly = selectedDate;
            } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
              // Adjust the date to remove time and prevent timezone shift
              localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]; // Returns 'yyyy-MM-dd'
              formValues[key] = localDateOnly;
            } else {
              localDateOnly = ""; // Set to empty if no valid date
            }

          }

          fieldList.push({
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
            SubFolderID: ctrlsfi != undefined ? ctrlsfi.subfolderID : 0,
            ChildFields: [],
            id: frmctrl != undefined ? frmctrl.id : 0
          });
        }
      }

      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      let indexDefault = fieldList.findIndex(n => n.FieldName == 'Address');
      let AddressDefault = fieldList.find(n => n.FieldName == 'Address');
      var checkcity = [];
      checkcity = this.arryaControlNameIdpare.filter(e => e.name == 'City');
      if (checkcity.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'City').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["City"],
          "childFieldType": 3
        });
      }
      var checkstate = [];
      checkstate = this.arryaControlNameIdpare.filter(e => e.name == 'State');
      if (checkstate.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'State').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["State"],
          "childFieldType": 2
        });
      }
      var checkzip = [];
      checkzip = this.arryaControlNameIdpare.filter(e => e.name == 'ZipCode');
      if (checkzip.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'ZipCode').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["ZipCode"],
          "childFieldType": 4
        });
      }
      var checkcountry = [];
      checkcountry = this.arryaControlNameIdpare.filter(e => e.name == 'Country');
      if (checkcountry.length > 0) {
        AddressDefault.ChildFields.push({
          "id": this.arryaControlNameIdpare.find(e => e.name == 'Country').id,
          "fieldID": AddressDefault.FieldID,
          "fieldValue": formValues["Country"],
          "childFieldType": 1
        });
      }
      fieldList = fieldList.filter(function (value, index) {
        return index != indexDefault;
      });
      fieldList.splice(indexDefault, 0, AddressDefault);
      /************/
      /***********/

      this.dynamicArrayAddress.forEach((element, i) => {
        i = i + 1;
        let cityctrl = this.arryaControlNameIdpare.find(e => e.name == 'City' + i);
        let statectrl = this.arryaControlNameIdpare.find(e => e.name == 'State' + i);
        let zipcodectrl = this.arryaControlNameIdpare.find(e => e.name == 'ZipCode' + i);
        let countryctrl = this.arryaControlNameIdpare.find(e => e.name == 'Country' + i);
        let indexDynamic = fieldList.findIndex(n => n.FieldName == 'Address' + i);
        let AddressDynamic = fieldList.find(n => n.FieldName == 'Address' + i);
        if (AddressDynamic != undefined) {
          AddressDynamic.ChildFields.push({
            "id": cityctrl != undefined ? cityctrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["City" + i],
            "childFieldType": 3
          })
          AddressDynamic.ChildFields.push({
            "id": statectrl != undefined ? statectrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["State" + i],
            "childFieldType": 2
          })
          AddressDynamic.ChildFields.push({
            "id": zipcodectrl != undefined ? zipcodectrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["ZipCode" + i],
            "childFieldType": 4
          })
          AddressDynamic.ChildFields.push({
            "id": countryctrl != undefined ? countryctrl.id : 0,
            "fieldID": AddressDynamic.FieldID,
            "fieldValue": formValues["Country" + i],
            "childFieldType": 1
          })

          fieldList = fieldList.filter(function (value, index) {
            return index != indexDynamic;
          });
          fieldList.splice(indexDynamic, 0, AddressDynamic);
        }
      });
      fieldList = fieldList.filter(x => x.FieldName != "Status");
      //********** */

      //fieldList=fieldList.filter(x=>x.id!=0 && x.FieldValue!="");    
      this.addCoreVm.ImageUrl = this.ImagePathURL;
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.TypeID = Number(this.TypeIdDrp) > 0 ? Number(this.TypeIdDrp) : 0;
      this.addCoreVm.Tags = this.tagvalues;
      this.addCoreVm.officeID = this.myOfficeID;
      this.addCoreVm.OfficeIDList = this.OfficeIDList;
      this.addCoreVm.Status = formValues.Status;
      this.loaderService.show();
      this.coreService.saveCoreUserDetails(this.addCoreVm).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
            this.loaderService.hide();
            this.myFormGroup.markAsPristine();
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
            this.getCoreUserDetails();
            //this.getCoreUserDetailsforSubFolderId();
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }



  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }



  PreviousRecord() {
    this.matTabIndex = 0;
    if (this.CCCList.length > 0) {
      var transactionID = sessionStorage.getItem('transactionID');
      var Index = this.CCCList.findIndex(el => el.coreID === Number(transactionID));
      Index = Index - 1;
      var check;
      check = this.CCCList[Index];
      if (check != null && check != undefined) {
        if (Index == 0) {
          this.PreviousButton = true;
          this.NextButton = false;
        }
        if (Index == this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = true;
        }
        if (Index != 0 && Index != this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = false;
        }

        var CheckFields = [];
        CheckFields = check.fields.filter(x => x.fieldName == "Type");
        if (CheckFields.length > 0) {
          this.TypeIdDrp = CheckFields[0].subFolderID;
          sessionStorage.setItem('transactionID', check.coreID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.coreID;
          this.getCoreUserDetails();
          this.GetAllMedicationList();
          this._dataSharingService.sendNextPreviousDocumentFromCore(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromCore(true);
          this._dataSharingService.sendNextPreviousForTouchesFromCore(1);
        } else {
          this.TypeIdDrp = 0;
          sessionStorage.setItem('transactionID', check.coreID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.coreID;
          this.getCoreUserDetails();
          this.GetAllMedicationList();
          this._dataSharingService.sendNextPreviousDocumentFromCore(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromCore(true);
          this._dataSharingService.sendNextPreviousForTouchesFromCore(1);
        }
      }
    }
  }



  NextRecord() {
    this.matTabIndex = 0;
    if (this.CCCList.length > 0) {
      var transactionID = sessionStorage.getItem('transactionID');
      var Index = this.CCCList.findIndex(el => el.coreID === Number(transactionID));
      Index = Index + 1;
      var check;
      check = this.CCCList[Index];
      if (check != null && check != undefined) {
        if (Index == 0) {
          this.PreviousButton = true;
          this.NextButton = false;
        }
        if (Index == this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = true;
        }
        if (Index != 0 && Index != this.CCCList.length - 1) {
          this.PreviousButton = false;
          this.NextButton = false;
        }
        var CheckFields = [];
        CheckFields = check.fields.filter(x => x.fieldName == "Type");
        if (CheckFields.length > 0) {
          this.TypeIdDrp = CheckFields[0].subFolderID;
          sessionStorage.setItem('transactionID', check.coreID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.coreID;
          this.getCoreUserDetails();
          this.GetAllMedicationList();
          this._dataSharingService.sendNextPreviousDocumentFromCore(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromCore(true);
          this._dataSharingService.sendNextPreviousForTouchesFromCore(true);
          this._dataSharingService.sendNextPreviousForTaskFrom3C(true);
        } else {
          this.TypeIdDrp = 0;
          sessionStorage.setItem('transactionID', check.coreID);
          sessionStorage.setItem('TypeID', (this.TypeIdDrp).toString());
          this.transactionID = check.coreID;
          this.getCoreUserDetails();
          this.GetAllMedicationList();
          this._dataSharingService.sendNextPreviousDocumentFromCore(true);
          this._dataSharingService.sendNextPreviousForRightPanelFromCore(true);
          this._dataSharingService.sendNextPreviousForTouchesFromCore(true);
          this._dataSharingService.sendNextPreviousForTaskFrom3C(true);
        }
      }
    }
  }

  /* Left Pannel User Fields*/
  openUserDetail() {
    this.showUserDetail = !this.showUserDetail;
  }
  /* Left Pannel User Fields*/

  /* CONTACT LIST IN RESPONSIVE */
  openContactList() {
    this.showContactList = !this.showContactList;
  }
  /* CONTACT LIST IN RESPONSIVE */

  /* DOCUMENT DETAL OPEN/CLOSE */
  getDocumentDetail(message: boolean) {
    this.openDocumentDetail = message;
  }
  getClose(closeDetail: boolean) {
    this.openDocumentDetail = closeDetail;
  }


  openAIToolDetail: boolean = false;
  azureblobPath: string = "";
  documentsId: number = 0;
  documentNames: string = "";
  // typeIdForTask:number=0;

  getBindFieldDetail(message: boolean) {
    this.openbindFieldsDetail = message;
  }

  getAIDetails(document: any) {
    this.azureblobPath = document.azureblobPath;
    this.documentsId = document.fileManagerItemID;
    this.documentNames = document.name;
    this.openAIToolDetail = true;
  }

  getAIDetailsFromDocDetails(document: any) {
    this.azureblobPath = document.documentPath;
    this.documentsId = document.fileManagerItemID;
    this.documentNames = document.documentName;
    this.openAIToolDetail = true;
    this.openDocumentDetail = false;
  }

  getCloseAIToolDetail() {
    this.openAIToolDetail = false;
  }

  getCloseBindFieldDetail() {
    this.openbindFieldsDetail = false;
  }



  /* DOCUMENT DETAL OPEN/CLOSE */

  openAIDetail: any
  /* AI DETAL OPEN/CLOSE */
  getAIDetail(message: boolean) {
    this.openAIDetail = message;
  }


  getAIClose(closeDetail: boolean) {
    this.openAIDetail = closeDetail;
  }
  /* AI DETAL OPEN/CLOSE */


  /* Share Docuemnts OPEN/CLOSE */
  getShareFile(message: boolean) {
    this.showShareFile = message;
  }

  getCloseShareFile(closeShare: boolean) {
    this.showShareFile = closeShare;
  }

  getShareFaxFile(message: boolean) {
    this.showShareFaxFile = message;
  }

  getCloseShareFaxFile(closeShare: boolean) {
    this.showShareFaxFile = closeShare;
  }
  /* Share Docuemnts OPEN/CLOSE */

  /* Docuemnt Viewer OPEN/CLOSE */
  getdocumentViewer(message: boolean) {
    this.documentViewer = message;
  }

  getCloseDocumentViewer(closeShare: boolean) {
    this.documentViewer = closeShare;
  }
  /* Docuemnt Viewer OPEN/CLOSE */

  gethtmlData(message: boolean) {
    this.htmlData = message;
  }

  getCloseHtmlData(closeShare: boolean) {
    this.htmlData = closeShare;
  }

  mainModuleNameFileManager: string = "File Manager";



  /* CREATE TOCUHES  OPEN/CLOSE */
  getshowCreate(messages: boolean) {
    this.showCreateTouches = messages;
  }

  closeTouches(messages: boolean) {
    this.showCreateTouches = messages;
  }
  /* CREATE TOCUHES  OPEN/CLOSE */

  /* Contact Detail OPEN/CLOSE */
  getContactDetail(messages: boolean) {
    this.showContactdetail = messages;
  }

  getCloseDetail(message: boolean) {
    this.showContactdetail = message;
  }
  /* Contact Detail OPEN/CLOSE */

  /* Create Task OPEN/CLOSE */
  getcreateTask(messages: boolean) {
    this.showCreateTask = messages;
  }

  closeCreateTask(messages: boolean) {
    this.showCreateTask = messages;
  }
  /* Create Task OPEN/CLOSE */

  /* SHow LINK PI  OPEN/CLOSE */
  getLinkPI(messages: boolean) {
    this.showLinkPI = messages;
  }

  closeLinkPI(messages: boolean) {
    this.showLinkPI = messages;
  }
  /* SHow LINK PI  OPEN/CLOSE */

  /* Task Detail  OPEN/CLOSE */
  getTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
  }
  closeTaskDetail(messages: boolean) {
    this.showTaskDetail = messages;
  }

  showTouches: boolean = false;
  showTask: boolean = false;
  showTaskListsLeft: boolean = false;

  showEmail: boolean = false;
  showFormReports: boolean = false;
  showCustomInfo: boolean = false;

  getAllFoldersField(event) {
    this.matTabIndex = event.index;
    this.showTask = false;


    this._dataSharingService.sendHideTaskListCore();
    if (event.tab.textLabel == "Activity" || event.index == 1) {
      this.showTouches = true;
    }

    if (event.tab.textLabel == "Custom Info" || event.index == 2) {
      this.showCustomInfo = true;
    }

    if (event.tab.textLabel == "Task" || event.index == 3) {
      this.showTask = true;
      this.settingService.openTaskTrigger.next(null);
    }

    if (event.tab.textLabel == "Email" || event.index == 4) {
      this.showEmail = true;
    }

    if (event.tab.textLabel == "Form Reports" || event.index == 5) {
      this.showFormReports = true;
      this.settingService.openFormReportTrigger.next('Core');
    }

  }

  getAllFoldersFieldNew(event, subModules: any[]) {
    this.matTabIndex = event.index;
    this.showTask = false;
    const selectedTabIndex = event.index;
    const selectedSubModule = subModules[selectedTabIndex];
    const tabText = event.tab.textLabel.toUpperCase();
    this._dataSharingService.sendHideTaskListCore();

    if (selectedSubModule.mainModuleName.toUpperCase() === "ACTIVITY") {
      this.showTouches = true;
    }

    if (selectedSubModule.mainModuleName.toUpperCase() === "CUSTOM INFO") {
      this.showCustomInfo = true;
    }

    if (selectedSubModule.mainModuleName.toUpperCase() === "TASKS") {
      this.showTask = true;
      this.settingService.openTaskTrigger.next(null);
    }

    if (selectedSubModule.mainModuleName.toUpperCase() === "EMAIL") {
      this.showEmail = true;
    }

    if (selectedSubModule.mainModuleName.toUpperCase() === "FORM REPORTS") {
      this.showFormReports = true;
      this.settingService.openFormReportTrigger.next('Core');
    }

  }

  OpenTaskLists(val: any) {
    this.settingService.openTaskTrigger.next(val);
    this.settingService.openMyTaskTrigger.next(null);
  }


  getMyTask() {
    this.settingService.openMyTaskTrigger.next("getMyTask");
    this.settingService.openTaskTrigger.next(null);
  }

  showMap = false;
  urlSafe: SafeResourceUrl;

  showLocationOnMap(add: string) {
    const zipCode = this.myFormGroup.get('ZipCode').value;
    const city = this.myFormGroup.get('City').value
    const state = this.myFormGroup.get('State').value
    let url = `https://maps.google.com/maps?q=${add}${city}${state}${zipCode}=&output=embed`;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.showMap = !this.showMap;
  }

  closeMap() {
    this.showMap = false;
  }


  clearDate(field) {
    return field.fieldValue = "";
  }

  expandUserInfo = false;
  FormReportfolderList: any = [] = [];
  cType: number = 1;
  FormFolderReportList: any = [] = [];
  previousCoreUserList: any = [] = [];

  // expandUserDetail(){
  //   this.expandUserInfo = !this.expandUserInfo
  // }

  expandUserDetail() {
    this.expandUserInfo = !this.expandUserInfo;
    if (this.expandUserInfo == true) {
      this.previousCoreUserList = [...this.coreUserList];
      this.coreUserList;
      this.coreUserList = this.reorderUsers([...this.coreUserList]);
    } else {
      this.coreUserList = [...this.previousCoreUserList];
    }
  }

  reorderUsers(users: any[]): any[] {
    return users.sort((a, b) => ((a.data?.length || 0) > 0 ? 1 : (b.data?.length || 0) > 0 ? -1 : 0));
    // return users.sort((a, b) => (a.id === 0 ? 1 : b.id === 0 ? -1 : 0));
  }

  GetFormReportFolderMappingsFor3C() {
    var ReqModel = {
      cType: this.cType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.getFormReportFolderMappingsFor3C(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.FormReportfolderList = this.responseHolder.data.topForms;
          this.FormFolderReportList = this.responseHolder.data.formReportFolders;
        }
        else {
          this.FormReportfolderList = [];
          this.FormFolderReportList = [];
        }
      }
      else {
        this.FormReportfolderList = [];
        this.FormFolderReportList = [];
      }
    });
  }

  openHTML(record: any) {
    //return;
    const dialogRef = this.dialog.open(OpenHTMLFormComponent, {
      data: {
        htmlData: record,
        transactionID: Number(sessionStorage.getItem('transactionID')),
        type: 1, //  Core=1, Contact=2, Company=3
        panelClass: 'previweHTMLForm',
      }
    });
  }

  OpenMedicationPopUP(templateRef: TemplateRef<any>) {

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    let thirdPartyApiID = 0;
    if (this.associatedAPIs && this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
      thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
      this.GetAllCoreCarePeriods();
      this.dialog.open(templateRef, {
        panelClass: 'signatureModal',
      });
      //officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
    }
    else if (thirdPartyApiID == 0) {
      this.toastr.warning('PointClickCare is not activated. Please activate it in Settings > Integrations and complete endpoint field mappings.', '', {
        timeOut: 3000,
      });
      return;
    }

  }

  close() {
    this.dialog.closeAll();
  }

  GetAllCoreCarePeriods() {
    this.loaderService.show();
    var ReqModel = {
      CoreID: this.transactionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.GetAllCoreCarePeriods(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.carePeriodList = this.responseHolder.data;
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }
  @ViewChild('startDate') startDatePicker: MatDatepicker<Date>;
  @ViewChild('endDate') endDatePicker: MatDatepicker<Date>;

  // Function to get properly formatted UTC date string
  convertToUTCFormat(date: Date): string {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      throw new Error("Invalid Date object provided");
    }

    // Format the date in ISO 8601 with milliseconds and 'Z' (UTC)
    return date.toISOString();
  }


  // Example usage
  getStartDate(): string {
    if (this.startDatePicker && this.startDatePicker._selected) {
      return this.convertToUTCFormat(this.startDatePicker._selected);
    }
    return null;
  }

  getEndDate(): string {
    if (this.endDatePicker && this.endDatePicker._selected) {
      return this.convertToUTCFormat(this.endDatePicker._selected);
    }
    return null;
  }
  AddCarePeriodPCC() {
    this.addCarePeriodErrors = [];
    const carePeriodType = (document.getElementById('carePeriodType') as HTMLSelectElement).value;
    const carePeriodName = (document.getElementById('carePeriodName') as HTMLInputElement).value;
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();
    if (!carePeriodName) {
      this.toastr.warning('Please enter Care Period Name.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (carePeriodType == "ENCOUNTER" && !startDate) {
      this.toastr.warning('Please enter Start Date for Care Period Type ENCOUNTER.', '', {
        timeOut: 3000,
      });
      return;
    }

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    let thirdPartyApiID = 0;
    if (this.associatedAPIs && this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
      thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
      //officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
    }
    else if (thirdPartyApiID == 0) {
      this.toastr.warning('PointClickCare is not activated. Please activate it in Settings > Integrations and complete endpoint field mappings.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.loaderService.show();
    var ReqModel = {
      CarePeriodname: carePeriodName,
      CarePeriodType: carePeriodType,
      StartDateTime: startDate,
      EndDateTime: endDate,
      ThirdPartyApiID: thirdPartyApiID,
      CoreID: this.transactionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.AddCarePeriodPCC(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.errors.length > 0) {
            this.addCarePeriodErrors = this.responseHolder.data.errors;
            this.toastr.warning('Please fix care period warning(s) and try again.', '', {
              timeOut: 3000,
            });
          }
          else {
            const carePeriodType = document.getElementById('carePeriodType') as HTMLSelectElement | null;
            const carePeriodName = document.getElementById('carePeriodName') as HTMLInputElement | null;
            (document.getElementById('startDateInput') as HTMLInputElement).value = '';
            (document.getElementById('endDateInput') as HTMLInputElement).value = '';

            if (carePeriodType) carePeriodType.value = '';
            if (carePeriodName) carePeriodName.value = '';
            this.toastr.success('Added successfully.', '', {
              timeOut: 3000,
            });
            this.carePeriodList = this.responseHolder.data.carePeriodFlowricsResponseModels;
          }
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }
  selectedpCCPeriodID: any = 0;
  onCarePeriodSelect(event: any) {
    const selectedValue = event.target.value;
    this.selectedpCCPeriodID = selectedValue;
  }
  AddMedicationPCC() {

    if (this.selectedpCCPeriodID > 0) {

    }
    else {
      this.toastr.warning('Please select Care Period.', '', {
        timeOut: 3000,
      });
      return;
    }

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    let thirdPartyApiID = 0;
    if (this.associatedAPIs && this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
      thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
      //officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
    }
    if (thirdPartyApiID > 0) {

    }
    else {
      this.toastr.warning('Please map a PointClickCare integration in settings to sync medications.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.loaderService.show();
    var ReqModel = {
      MedicationIDs: this.selectedPCCMedication,
      PCCPeriodID: this.selectedpCCPeriodID,
      ThirdPartyApiID: thirdPartyApiID,
      CoreID: this.transactionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    }
    this.settingsService.AddMedicationPCC(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.errors.length > 0) {
            this.addCarePeriodErrors = this.responseHolder.data.errors;
            if (this.responseHolder.data.isPartialUpdate) {
              this.toastr.warning('Few Medication were not added, please check error details in respective medication.', '', {
                timeOut: 3000,
              });
            }
            else {
              this.toastr.error('Medication were not added, please check error details in respective medication.', '', {
                timeOut: 3000,
              });
            }

            this.GetAllMedicationList();
            this.dialog.closeAll();
          }
          else {
            this.selectedPCCMedication = [];
            this.toastr.success('Added successfully.', '', {
              timeOut: 3000,
            });
            this.dialog.closeAll();
            this.GetAllMedicationList();
          }
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  medicationForm: FormGroup;
  currentMedication: any;

  // Temporary dropdown options - replace with your actual data sources
  dosageUomOptions = [
    "application",
    "applicator",
    "applicatorful",
    "bar",
    "blister",
    "buccal system",
    "can",
    "caplet",
    "capsule",
    "cc",
    "centimeter",
    "device",
    "dose",
    "drop",
    "each",
    "gram",
    "film",
    "gum",
    "implant",
    "inch",
    "inhalation",
    "insert",
    "IU",
    "IUD",
    "kilogram",
    "kit",
    "lancet",
    "liter",
    "lozenge",
    "mcg",
    "mcg/hr",
    "mcg/min",
    "mCi",
    "mEq",
    "mg",
    "mg/ml",
    "ml/hr",
    "mMol",
    "million units",
    "ml",
    "milligram",
    "milliliter",
    "milliunit",
    "oral strips",
    "other",
    "ounce",
    "packet",
    "pad",
    "patch",
    "PE units",
    "pen needle",
    "piece",
    "puff",
    "pump",
    "ribbon",
    "ring",
    "sachet",
    "scoop",
    "sponge",
    "spray",
    "stick",
    "strip",
    "suppository",
    "swab",
    "syringe",
    "tablet",
    "tampon",
    "tbsp",
    "troche",
    "tsp",
    "unit",
    "unspecified",
    "vial",
    "wafer"
  ];
  frequencyOptions = ["one time a day", "in the morning", "in the afternoon", "in the evening", "at bedtime", "two times a day", "three times a day", "before meals", "after meals", "with meals", "four times a day", "before meals and at bedtime", "five times a day", "every hour", "after meals and at bedtime", "every morning and at bedtime", "every shift", "every day shift", "every evening shift", "every night shift", "every day and night shift", "every day and evening shift", "every evening and night shift", "every 2 hours", "every 3 hours", "every 4 hours", "every 5 hours", "every 6 hours", "every 8 hours", "every 10 hours", "every 12 hours", "every 16 hours", "every 18 hours", "every 24 hours", "every 30 hours", "every 36 hours", "every 48 hours", "every 60 hours", "every 72 hours", "every 96 hours", "Other"];
  scheduleOptions = ["Routine", "PRN", "One Time Only", "STAT"];//"Titration"
  scheduleTypeOptions = ["Everyday", "Odd Days", "Even Days", "Every Other Day", "Other"];
  routeOptions = ["alternating_nostrils", "buccally", "by_mouth", "dental", "enterally", "hemodialysis", "in_both_ears", "in_both_eyes", "in_both_nostrils", "in_each_nostril", "in_left_ear", "in_left_eye", "in_left_nostril", "in_nostril", "in_right_ear", "in_right_eye", "in_right_nostril", "in_the_cheek", "in_the_peritoneal_cavity", "in_the_urethra", "in_vitro", "inhale_orally", "inhale_orally_via_nebulizer", "intra-arterially", "intra-articularly", "intracavernosal", "intradermally", "intramuscularly", "intraocularly", "intraspinal", "intrathecally", "intrauterine", "intravenously", "intravesical", "miscellaneous", "mucous_membrane", "orally", "perfusion", "rectally", "subcutaneously", "sublingually", "topically", "transdermally", "translingually", "vaginally", "via_dh-tube", "via_epidural_injection", "via_g-tube", "via_graft_or_port", "via_implant", "via_irrigation", "via_j-tube", "via_mask", "via_nd-tube", "via_ng-tube", "via_nj-tube", "via_peg-tube", "via_trach", "via_vent", "within_the_pleura"];
  prnTimingOptions = ['Hours', 'Minutes']; // As specified
  statusOptions = ['Current', 'Discontinued']; // As specified

  @ViewChild('medicationDialog') medicationDialog: TemplateRef<any>;

  // Add this method to handle the change event
  onScheduleTypeChange(): void {
    const alternateScheduleControl = this.medicationForm.get('AlternateScheduleType');

    if (this.medicationForm.get('ScheduleType').value === 'Other') {
      alternateScheduleControl.enable();
      alternateScheduleControl.setValidators([Validators.required]); // Add required validator if needed
    } else {
      alternateScheduleControl.disable();
      alternateScheduleControl.clearValidators();
      alternateScheduleControl.setValue(''); // Clear the value when disabled
    }
    alternateScheduleControl.updateValueAndValidity();
  }


  onFrequencyChange(): void {
    const alternateFrequency = this.medicationForm.get('AlternateFrequency');

    if (this.medicationForm.get('Frequency').value === 'Other') {
      alternateFrequency.enable();
      alternateFrequency.setValidators([Validators.required]); // Add required validator if needed
    } else {
      alternateFrequency.disable();
      alternateFrequency.clearValidators();
      alternateFrequency.setValue(''); // Clear the value when disabled
    }
    alternateFrequency.updateValueAndValidity();
  }

  setupConditionalValidation() {
    // Trigger validation when Schedule changes
    this.medicationForm.get('Schedule').valueChanges.subscribe(scheduleValue => {
      this.updateConditionalValidators(scheduleValue);
    });

    // Initial validation for edit mode
    if (this.medicationID > 0) {
      this.updateConditionalValidators(this.medicationForm.get('Schedule').value);
      this.medicationForm.markAllAsTouched();
    }
  }
  onPRNWithTimeChange(event: any) {
    this.updateConditionalValidators(this.medicationForm.get('Schedule').value);
  }
  updateConditionalValidators(scheduleValue: string) {
    const frequencyControl = this.medicationForm.get('Frequency');
    const scheduleTypeControl = this.medicationForm.get('ScheduleType');
    const scheduleControl = this.medicationForm.get('Schedule');
    const isPrnWithDirectionsControl = this.medicationForm.get('IsPrnWithDirections');
    const prnTimingControl = this.medicationForm.get('PrnTiming');
    const prnTimingValueControl = this.medicationForm.get('PrnTimingValue');
    const additionalDirectionsControl = this.medicationForm.get('AdditionalDirections');

    // Reset all conditional validators first
    frequencyControl.clearValidators();
    scheduleTypeControl.clearValidators();
    prnTimingControl.clearValidators();
    prnTimingValueControl.clearValidators();
    additionalDirectionsControl.clearValidators();
    // Apply new validators based on schedule value
    switch (scheduleValue) {
      case 'Routine':
        frequencyControl.setValidators(Validators.required);
        scheduleTypeControl.setValidators(Validators.required);
        break;
      case 'PRN':
        if (isPrnWithDirectionsControl.value) {
          prnTimingControl.enable();
          prnTimingValueControl.enable();
          prnTimingControl.setValidators(Validators.required);
          prnTimingValueControl.setValidators(Validators.required);
        }
        else {
          prnTimingControl.disable();
          prnTimingValueControl.disable();
          additionalDirectionsControl.setValidators(Validators.required);
        }
        break;
      // No additional validators for 'One Time Only' and 'STAT'
    }

    if (isPrnWithDirectionsControl.value == false) {

      prnTimingControl.disable();
      prnTimingValueControl.disable();
      //additionalDirectionsControl.setValidators(Validators.required);
    }

    // Update validity
    frequencyControl.updateValueAndValidity();
    scheduleTypeControl.updateValueAndValidity();
    prnTimingControl.updateValueAndValidity();
    prnTimingValueControl.updateValueAndValidity();
    additionalDirectionsControl.updateValueAndValidity();
    scheduleControl.updateValueAndValidity();
    if (scheduleValue && scheduleValue.toLowerCase() === 'Titration'.toLowerCase()) {
      scheduleControl.patchValue("");
      scheduleControl.updateValueAndValidity();
    }
  }
  formatDateForDisplay(inputDate: string | null | undefined): string {
    if (!inputDate) return '';

    try {
      // Handle both Date objects and strings
      const date = new Date(inputDate);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.warn(`Invalid date format received: ${inputDate}`);
        return '';
      }

      // Format components
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    } catch (error) {
      console.error(`Date formatting error for input: ${inputDate}`, error);
      return '';
    }
  }

  validateDateString(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? '' : dateString;
  }
  openEditDialog(medicationID: number): void {
    this.medicationID = medicationID;
    this.medicationForm = this.formBuilder.group({
      MedicationID: [null],
      Name: ['', Validators.required],
      Schedule: ['', Validators.required], // Always required
      ScheduleType: [''],
      AlternateScheduleType: [{ value: '', disabled: true }],
      Dosage: ['', Validators.required], // Always required
      Dosage_UOM: ['', Validators.required], // Always required
      Frequency: [''],
      AlternateFrequency: [{ value: '', disabled: true }],
      Route: ['', Validators.required],
      StartDate: [''],
      EndDate: [''],
      PrnTiming: [''],
      IndicationsForUse: [''],
      PrnTimingValue: [''],
      IsPrnWithDirections: [false],
      Status: ['', Validators.required],
      ErrorJson: [''],
      IsSynced: [0],
      AdditionalDirections: ['']
    });
    if (medicationID == 0) {
      this.setupConditionalValidation();
      this.dialog.open(this.medicationDialog, {
        width: '800px',
        disableClose: true
      });
      return;
    }
    this.loaderService.show();
    let request = {
      MedicationID: medicationID,
      CoreID: this.transactionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    };

    this.settingService.GetMedicationByID(request).subscribe({
      next: (response) => {

        if (response.data.frequency && !this.frequencyOptions.includes(response.data.frequency) && !response.data.alternateFrequency) {

          response.data.alternateFrequency = response.data.frequency;
          //response.data.frequency="Other";
        }
        else if (!response.data.frequency && response.data.alternateFrequency) {
          // Case 2: No frequency but alternateFrequency exists
          //response.data.frequency="Other";
        }
        else if (!response.data.frequency && !response.data.alternateFrequency) {
          // Case 3:
          // response.data.frequency="Other";
        }

        if (response.data.status !== "Current") {
          response.data.status = "Discontinued";

        }
        const validScheduleTypes = [
          "Everyday",
          "Odd Days",
          "Even Days",
          "Every Other Day",
          "Other"
        ];
        if (response.data.schedule && response.data.schedule.toLowerCase() === 'Routine'.toLowerCase()) {
          const scheduleType = response.data.scheduleType?.toLowerCase();
          const isMatch = validScheduleTypes.some(type => type.toLowerCase() === scheduleType);

          if (!isMatch) {
            response.data.scheduleType = "";
          }
        }
        // this.currentMedication = response.data;

        // Map API response to form controls
        const formData = {
          MedicationID: response.data.medicationID,
          Name: response.data.name == "Not specified" ? "" : response.data.name,
          Schedule: response.data.schedule,
          ScheduleType: response.data.scheduleType,
          AlternateScheduleType: response.data.alternateScheduleType,
          Dosage: response.data.dosage == "Not specified" ? "" : response.data.dosage,
          Dosage_UOM: response.data.dosage_UOM == "Not specified" ? "" : response.data.dosage_UOM,
          Frequency: response.data.frequency,
          AlternateFrequency: response.data.alternateFrequency,
          Route: response.data.route == "Not specified" ? "" : response.data.route,
          StartDate: this.validateDateString(response.data.startDate),
          EndDate: this.validateDateString(response.data.endDate),
          PrnTiming: response.data.prnTiming,
          PrnTimingValue: response.data.prnTimingValue,
          IsPrnWithDirections: (!response.data.isPrnWithDirections && response.data.schedule == "PRN"),
          Status: response.data.status,
          ErrorJson: response.data.errorJson,
          IsSynced: response.data.isSynced,
          AdditionalDirections: response.data.additionalDirections,
          IndicationsForUse: response.data.indicationsForUse
        };
        this.medicationForm.patchValue(formData);
        this.onScheduleTypeChange();
        this.onFrequencyChange();
        this.setupConditionalValidation();
        this.loaderService.hide();
        this.dialog.open(this.medicationDialog, {
          width: '800px',
          disableClose: true
        });
      },
      error: (err) => {
        console.error('Error fetching medication:', err);
        this.loaderService.hide();
      }
    });
  }

  updateMedication(): void {
    if (this.medicationForm.invalid) return;

    this.loaderService.show();
    let updateRequest = {
      MedicationModel: this.medicationForm.value,
      MedicationID: this.medicationID,
      CoreID: this.transactionID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
    };
    if (!(updateRequest.MedicationModel.MedicationID > 0)) {
      updateRequest.MedicationModel.MedicationID = 0;
    }

    if (updateRequest.MedicationModel) {

      if (updateRequest.MedicationModel.StartDate) {
        let selectedDate = updateRequest.MedicationModel.StartDate;

        // If selectedDate is a string, set localDateOnly to the string value directly
        if (typeof selectedDate === "string") {
          updateRequest.MedicationModel.StartDate = selectedDate;
        } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
          // Adjust the date to remove time and prevent timezone shift
          updateRequest.MedicationModel.StartDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0]; // Returns 'yyyy-MM-dd'
        } else {
          updateRequest.MedicationModel.StartDate = ""; // Set to empty if no valid date
        }
      }

      if (updateRequest.MedicationModel.EndDate) {
        let selectedDate = updateRequest.MedicationModel.EndDate;

        // If selectedDate is a string, set localDateOnly to the string value directly
        if (typeof selectedDate === "string") {
          updateRequest.MedicationModel.EndDate = selectedDate;
        } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
          // Adjust the date to remove time and prevent timezone shift
          updateRequest.MedicationModel.EndDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0]; // Returns 'yyyy-MM-dd'
        } else {
          updateRequest.MedicationModel.EndDate = ""; // Set to empty if no valid date
        }
      }
    }

    this.settingService.UpdateMedicationByID(updateRequest).subscribe({
      next: (success) => {
        if (success) {
          this.medicationID = 0;
          // Handle success
          if (this.medicationID > 0) {
            this.toastr.success('Record updated successfully.', '', {
              timeOut: 3000,
            });
          }
          else {
            this.toastr.success('Record added successfully.', '', {
              timeOut: 3000,
            });
          }
          this.GetAllMedicationList();
          this.dialog.closeAll();
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error('Error updating medication:', err);
        this.toastr.error('Error Occurred.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
      }
    });
  }

  closeMedPopup(): void {
    this.dialog.closeAll();
  }
  deleteMedication(arg0: any) {
    throw new Error('Method not implemented.');
  }



  payChekSubmittedResult: any;
  isReCreate: boolean = false;
  paycheckErrorList: any = [] = [];


  SendtoPendingPatientPCC() {
    //== For Core====//

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    if (this.associatedAPIs.length > 0) {
      var checkPCC = [];
      checkPCC = this.associatedAPIs.filter(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true);
      if (checkPCC.length > 0) {
        this.showPCC = true;
      } else {
        this.showPCC = false;
      }
    }
    // if (this.typeId == undefined) {
    //   this.typeId = 0;
    // }

    this.payChekSubmittedResult = [];
    var result: any = [] = [];
    var objs = {
      name: this.transactionUserName,
      coreID: Number(this.transactionID),
      subFolderID: this.TypeIdDrp
    }
    result.push(objs);

    this.payChekSubmittedResult = result;
    this.paycheckErrorList = [];
    if (result.length > 0 && result != "" && result != undefined) {

      var coreListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          coreID: result[i].coreID,
          subFolderID: result[i].subFolderID,
        }
        coreListForPaychex.push(obj);
      }
      var ReqModel = {
        coreList: coreListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      //return;  
      this.loaderService.show();
      this.coreService.sendToPendingPatientPCC(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check: any = [];
            var checkError = [];
            check = this.responseHolder.data;
            check = check.pccResponses;

            let quotaExusted: any;
            let quotaExustedMessage = "";
            if (check.length > 0) {
              checkError = check.filter(x => x.errors != null);
              checkError.forEach(ne => {
                ne.errors.forEach(ee => {
                  if (ee.code == '100') {
                    quotaExusted = ee.code;
                    quotaExustedMessage = ee.detail;
                    var obj = {
                      name: "Temporary API Service Unavailability",
                      code: "API will start functioning at " + new Date(ee.xQuotaTimeToResetDateTime),
                      description: ee.detail,
                    }
                    this.paycheckErrorList.push(obj);
                    this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
                  }
                });
                ne.errors = ne.errors.filter(m => m.type == 0);
              });
              if (quotaExusted == '100') {
                return;
              }
              checkError = checkError.filter(x => x.errors.length != 0);
              if (checkError.length == 0) {
                this.getCoreUserDetailsAfterSendPCC();
                this.toastr.success('Record added in Pending Patient successfully.', '', {
                  timeOut: 3000,
                });
              } else {

                for (var i = 0, len = checkError.length; i < len; ++i) {

                  let list = [];
                  let name = "";
                  list = result.filter(x => x.coreID == Number(checkError[i].coreID));
                  if (list.length > 0) {
                    name = list[0].name;
                  }
                  if (checkError[i].errors != null) {
                    checkError[i].errors.forEach(eelement => {

                      var obj = {
                        name: name,
                        code: eelement.code,
                        description: eelement.detail,
                      }
                      this.paycheckErrorList.push(obj);
                    });
                  }
                }
                this.showPaycheckError("PointClickCare warning(s), please correct and submit again");
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }


  showPaycheckError(title: any = null) {
    const dialogRef = this.dialog.open(PaycheckErrorComponent, {
      data: {
        list: this.paycheckErrorList,
        title: title,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.isReCreate = result;
        this.SendtoPaychexRecordForCore(this.payChekSubmittedResult);
      }
    });
  }

  SendtoPaychexRecordForCore(result) {
    this.payChekSubmittedResult = result;
    this.paycheckErrorList = [];
    if (result.length > 0 && result != "" && result != undefined) {

      var coreListForPaychex = [];
      var thirdPartyApiID = 0;
      var officeThirdPartyApiID = 0;

      if (this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true)) {
        thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true).thirdPartyApiID;
        officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'Paychex' && x.isCoreMapped == true).officeThirdPartyApiID;
      }

      for (let i = 0; i < result.length; i++) {
        var obj = {
          coreID: result[i].selectedRecord,
          subFolderID: result[i].subFolderID,
        }
        coreListForPaychex.push(obj);
      }
      var ReqModel = {
        coreList: coreListForPaychex,
        folderID: this.folderID,
        thirdPartyApiID: thirdPartyApiID,
        officeThirdPartyApiID: officeThirdPartyApiID,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        isrecreate: this.isReCreate
      }
      //return;  
      this.loaderService.show();
      this.coreService.sendToPaychex(ReqModel).subscribe((response) => {
        if (response != undefined) {
          this.isReCreate = false;
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.loaderService.hide();
            var check = [];
            var checkError = [];
            check = this.responseHolder.data.response;
            if (check.length > 0) {
              checkError = check.filter(x => x.status != this.statusConst.statusSuccess);
              if (checkError.length == 0) {
                this.getCoreUserDetailsAfterSendPCC();
                this.toastr.success('Record added in Paychex successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                let list = [];
                let name = "";
                list = result.filter(x => x.selectedRecord == Number(checkError[0].data.content[0].employeeId));
                if (list.length > 0) {
                  name = list[0].name;
                }
                for (var i = 0, len = checkError[0].data.errors.length; i < len; ++i) {
                  var obj = {
                    name: name,
                    code: checkError[0].data.errors[i].code,
                    description: checkError[0].data.errors[i].description,
                  }
                  this.paycheckErrorList.push(obj);
                }
                this.showPaycheckError();
              }
            }
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

  getCoreUserDetailsAfterSendPCC() {
    let thirdPartyApiID = 0;
    let officeThirdPartyApiID = 0;

    this.associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    if (this.associatedAPIs && this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true)) {
      thirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).thirdPartyApiID;
      officeThirdPartyApiID = this.associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isCoreMapped == true).officeThirdPartyApiID;
    }

    this.transactionIDForTask = Number(this.transactionID);//Number(sessionStorage.getItem('transactionID'));
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.coreID = Number(this.transactionID); //Number(sessionStorage.getItem('transactionID'));
    this.coreVm.FolderId = Number(this.folderID);
    this.coreVm.subFolderID = Number(this.TypeIdDrp);
    this.coreVm.UserID = this.currentUser.UID;
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.coreVm.thirdPartyApiID = thirdPartyApiID;
    this.coreVm.officeThirdPartyApiID = officeThirdPartyApiID;
    this.loaderService.show();
    this.coreService.getCoreUserDetails(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          sessionStorage.setItem("PCCPatientID", response.data.patientId);
          sessionStorage.setItem("PCCPendingPatientID", response.data.pendingPatientId);
          this.pendingPatientId = response.data.pendingPatientId;
          if (this.pendingPatientId == null) {
            this.pccToolTip = "Send to PointClickCare";
          } else {
            this.pccToolTip = "Update to PointClickCare";
          }
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }
}



